module.exports = __webpack_public_path__ + "static/media/q5-icon.ec46caf0.png";